import React from 'react';
import { Linkedin, Github, Twitter, Globe } from 'lucide-react';
import { SocialLink } from './types';

interface ProfileCardSocialLinksProps {
  socialLinks: SocialLink[];
  variant: 'preview' | 'full';
}

const getIconByPlatform = (platform: string, size: 'sm' | 'md' = 'md'): React.ReactNode => {
  const sizeClass = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const platformLower = platform.toLowerCase();

  if (platformLower.includes('linkedin')) return <Linkedin className={sizeClass} />;
  if (platformLower.includes('github')) return <Github className={sizeClass} />;
  if (platformLower.includes('twitter') || platformLower.includes('x')) return <Twitter className={sizeClass} />;
  return <Globe className={sizeClass} />;
};

const ProfileCardSocialLinks: React.FC<ProfileCardSocialLinksProps> = ({
  socialLinks,
  variant
}) => {
  if (!socialLinks || socialLinks.length === 0) return null;

  const isPreview = variant === 'preview';

  if (isPreview) {
    return (
      <div className="pt-2 border-t border-border">
        <div className="flex items-center justify-center gap-2">
          {socialLinks.slice(0, 4).map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-6 h-6 bg-muted rounded flex items-center justify-center hover:bg-accent transition-colors duration-200 text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none"
            >
              {getIconByPlatform(link.platform, 'sm')}
            </a>
          ))}
        </div>
      </div>
    );
  }

  // Full variant
  return (
    <div className="pt-6 border-t border-border">
      <div className="flex items-center justify-center gap-4">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-accent transition-colors duration-200 text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            {getIconByPlatform(link.platform, 'md')}
          </a>
        ))}
      </div>
    </div>
  );
};

export default ProfileCardSocialLinks;
